import { NavTabs } from '../models';
import { GridColumnModel } from '../utils/common-interface';

export const getIntegrationNavList = (type: string, flag) => {
    let navList: NavTabs[] = [];

    switch (type) {
        case 'carrier-management': {
            if (flag) {
                // navList = [
                //     {
                //         name: 'Service Mapping',
                //         route: '/integration/carrier-management/store-config'
                //     }
                // ];
                navList = [
                    {
                        name: 'Active',
                        route: '/integration/service-mapping/active'
                    },
                    {
                        name: 'Inactive',
                        route: '/integration/service-mapping/in-active'
                    },
                    {
                        name: 'Unmapped',
                        route: '/integration/service-mapping/unmapped'
                    }
                ];
                break;
            } else {
                navList = [
                    {
                        name: 'Carrier Rules',
                        route: '/integration/carrier-management/carrier-rules'
                    },
                    // {
                    //     name: '3PL',
                    //     route: '/integration/carrier-management/third-party-logistics'
                    // },
                    // {
                    //     name: 'Service Mapping',
                    //     route: '/integration/carrier-management/store-config'
                    // }
                ];
                break;
            }
        }
    }
    return navList;
};

export const carrierRuleGridColumns: GridColumnModel[] = [
    {
        id: 1,
        name: 'Rule Name',
        isChecked: true,
        map: 'name'
    },
    {
        id: 2,
        name: 'Conditions',
        isChecked: true,
        map: 'carrier_conditions'
    },
    {
        id: 3,
        name: 'Sales Channel',
        isChecked: true,
        map: 'seller_marketplace',
        method: 'parseSalesChannel',
    },
    {
        id: 4,
        name: 'Shipping Method',
        isChecked: true,
        map: 'shipping_method'
    },
    {
        id: 5,
        name: 'Status',
        isChecked: true,
        map: 'active',
        method: 'parseCarrierRuleStatus'
    },
    {
        id: 6,
        name: 'Last Modified',
        isChecked: true,
        map: 'updated_at',
        method: 'formatMomentDate'
    },
    {
        id: 7,
        name: 'Priority',
        isChecked: true,
        map: 'priority'
    }
];

export const threePLColumns: GridColumnModel[] = [
    { id: 1, name: 'Name', isChecked: true, map: 'partner_mp_code' },
    {
        id: 2,
        name: 'Status',
        isChecked: true,
        map: 'is_active',
        method: 'ThreePartyLogisticsStatus'
    },
    {
        id: 3,
        name: 'Actions',
        isChecked: true,
        map: 'thirdPartyLogistics',
        method: 'parseAction',
        type: 'third-party-logistics'
    }
];
